const MenustralCycle = Object.freeze({
  REGULAR: 'Regular',
  IRREGULAR: 'Irregular',
  HEAVY: 'Heavy or prolonged bleeding',
  LIGHT: 'Light or scant bleeding',
  NONE: 'None',
  // POSTMENOPAUSE: 'None - postmenopause',
})

export default MenustralCycle